import * as React from 'react';
import {createContext, useContext, useMemo, useState} from 'react';
import TemplateListPage from "./pages/TemplateListPage";
import TemplateDetailPage from "./pages/TemplateDetailPage";
import {makeStyles, tokens} from "@fluentui/react-components";
import SettingsPage from "./pages/SettingsPage";

// All possible pages
type Page =
    | { kind: 'list' }
    | { kind: 'detail'; templateId: string }
    | { kind: 'settings' };

interface RouterContext {
    page: Page;
    setPage: (page: Page) => void;
}

const RouterContext = createContext<RouterContext>(null!);

export default function Router() {
    const [page, setPage] = useState<Page>({kind: 'list'});
    const value = useMemo(() => ({page, setPage}), [page]);
    return (
        <RouterContext.Provider value={value}>
            <RouterContent/>
        </RouterContext.Provider>
    );
}

const useStyles = makeStyles({
    animatedPage: {
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        padding: tokens.spacingHorizontalS,
        animationName: {
            from: {opacity: 0, transform: 'translateY(4px)'},
            to: {opacity: 1, transform: 'translateY(0)'},
        },
        animationDuration: '0.15s',
        animationTimingFunction: 'ease-out',
    }
});

function RouterContent() {
    const styles = useStyles();
    const {page} = useRouter();

    return (
        <div key={page.kind} className={styles.animatedPage}>
            {page.kind === 'list' && <TemplateListPage/>}
            {page.kind === 'detail' && <TemplateDetailPage templateId={page.templateId}/>}
            {page.kind === 'settings' && <SettingsPage/>}
        </div>
    );
}

export const useRouter: Function = () => useContext(RouterContext);

